
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Conclusion: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Conclusion: A Business Imperative</h2>
      
      <p className="mb-5 text-gray-700 leading-relaxed">
        For small businesses operating in 2025, zero-trust security isn't merely a technical consideration—it's a business imperative. 
        This approach acknowledges the reality that in today's interconnected environment, threats can originate from anywhere, 
        and traditional perimeter-based security provides insufficient protection.
      </p>
      
      <p className="mb-5 text-gray-700 leading-relaxed">
        By adopting zero-trust principles incrementally, even the smallest organizations can significantly enhance their security posture 
        without overwhelming their resources. While the investment in time and money is substantial, it pales in comparison to the 
        potential costs of experiencing a serious breach.
      </p>
      
      <p className="mb-8 text-gray-700 leading-relaxed">
        In an era where digital trust represents increasingly valuable currency, demonstrating your commitment to protecting client data 
        through zero-trust security practices isn't just about avoiding disaster—it's about building a foundation for sustainable business growth.
      </p>
      
      <div className="bg-itmgmt-light-blue p-6 rounded-lg my-8">
        <h3 className="text-xl font-semibold mb-3 text-itmgmt-dark-blue">Ready to strengthen your security posture?</h3>
        <p className="mb-4 text-gray-700">
          Our team can help you implement zero-trust principles with a customized security strategy designed for your business needs.
          We'll work with you to protect your critical data while keeping costs manageable.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild className="bg-itmgmt-medium-blue hover:bg-itmgmt-dark-blue">
            <Link to="/book">Schedule a Free Consultation</Link>
          </Button>
          <Button asChild variant="outline" className="border-itmgmt-medium-blue text-itmgmt-medium-blue hover:bg-itmgmt-light-blue/20">
            <Link to="/services/cybersecurity">Explore Our Cybersecurity Services</Link>
          </Button>
        </div>
      </div>
    </>
  );
};

export default Conclusion;
